import { __awaiter, __generator } from "tslib";
import { mergeOptions, objectDefinedNotNull } from "@pnp/common";
import { defaultPipelineBinder, cloneQueryableData } from "@pnp/odata";
import { GraphHttpClient } from "./graphhttpclient";
import { toAbsoluteUrl } from "./utils/toabsoluteurl";
var graphClientBinder = defaultPipelineBinder(function () { return new GraphHttpClient(); });
var send = function (operation) {
    return function (o, options) {
        return __awaiter(this, void 0, void 0, function () {
            var data, batchDependency, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = cloneQueryableData(o.data);
                        batchDependency = objectDefinedNotNull(data.batch) ? data.batch.addDependency() : function () { return; };
                        return [4 /*yield*/, toAbsoluteUrl(o.toUrlAndQuery())];
                    case 1:
                        url = _a.sent();
                        mergeOptions(data.options, options);
                        return [2 /*return*/, operation(Object.assign({}, data, {
                                batchDependency: batchDependency,
                                url: url,
                            }))];
                }
            });
        });
    };
};
export var graphGet = function (o, options) { return send(graphClientBinder("GET"))(o, options); };
export var graphPost = function (o, options) { return send(graphClientBinder("POST"))(o, options); };
export var graphDelete = function (o, options) { return send(graphClientBinder("DELETE"))(o, options); };
export var graphPatch = function (o, options) { return send(graphClientBinder("PATCH"))(o, options); };
export var graphPut = function (o, options) { return send(graphClientBinder("PUT"))(o, options); };
//# sourceMappingURL=operations.js.map